import { render, staticRenderFns } from "./MainLoggedView.vue?vue&type=template&id=2936478e&scoped=true&"
import script from "./MainLoggedView.vue?vue&type=script&lang=js&"
export * from "./MainLoggedView.vue?vue&type=script&lang=js&"
import style0 from "./MainLoggedView.vue?vue&type=style&index=0&id=2936478e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936478e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VIcon,VLayout,VSpacer})
